export function isUrlAllowed(url, allowedUrlHosts) {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch (_a) {
        return false;
    }
    if (parsed.protocol !== "https:") {
        return false;
    }
    if (parsed.username !== "" || parsed.password !== "") {
        return false;
    }
    return allowedUrlHosts.includes(parsed.hostname.toLowerCase());
}
